import { useContext } from 'react'

import AppContext from '@/common/context/app.context'

import useAlerts from './hooks/useAlerts/useAlerts'
import ShipmentAlertCard from './ShipmentAlertCard/ShipmentAlertCard'
import TransactionAlertCard from './TransactionAlertCard/TransactionAlertCard'
import * as Styles from './styles'

const AlertsSection = ({ isUnifiedDashboard }) => {
  const { info } = useContext(AppContext)
  const allowsShipments = info?.selectedStore?.preferences?.allows_shipments
  const returnPortalId = isUnifiedDashboard ? null : info?.selectedReturnPortal?.id

  const { shipmentAlertsCount, transactionAlertsCount, handleShipmentAlertClick, handleTransactionAlertClick } =
    useAlerts({ returnPortalId, isUnifiedDashboard })

  const showShipmentAlerts = allowsShipments && shipmentAlertsCount > 0
  const showTransactionAlerts = transactionAlertsCount > 0

  if (!showShipmentAlerts && !showTransactionAlerts) {
    return null
  }

  return (
    <Styles.Container>
      {showShipmentAlerts && <ShipmentAlertCard alertsCount={shipmentAlertsCount} onClick={handleShipmentAlertClick} />}
      {showTransactionAlerts && (
        <TransactionAlertCard alertsCount={transactionAlertsCount} onClick={handleTransactionAlertClick} />
      )}
    </Styles.Container>
  )
}

export default AlertsSection
